import React from 'react';
import { useIntl } from 'react-intl';
import { Icons } from '../../../../components/base/BootstrapComponents/BootstrapComponents';

export default function InDevelopment() {
  const { formatMessage } = useIntl();
  return (
    <div className="applicant-body flex-column">
      <div className="application-action-content-info">
        <div className="application-action-content-info-icon">
          <Icons width={24} height={24} customIcon icon="violation" />
        </div>
        <div className="application-action-content-info-text">{formatMessage({ id: 'in.development.info' })}</div>
      </div>
    </div>
  );
}
